<template>
  <section v-if="$role.restricAccess($route.name, 'view') && checkIsGMCanBet()">
    <!-- <breadcrumb-template :headtitle="$route.meta.title" :breadcrumbcurrent="$route.meta.title"></breadcrumb-template> -->
    <!-- <section> -->
    <!-- <v-dialog v-model="dialogForm" width="1200px" persistent> -->
    <v-card class="card-outline">
      <!-- <v-card-title class="headline headline_bg pb-6">
                        <v-row>
                            <v-col cols="12">
                                <span>Add bet</span>
                                <v-btn small class="float-right" color="error" @click="$router.push({name: 'bet_history'});">Go back</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title> -->

      <v-card-text class="pb-10 force-custom-bg">
        <v-row
          align="center"
          class="pt-6 d-flex justify-left"
          v-if="!$store.state.currentUser.isplayer"
        >
          <v-col cols="12" lg="3" class="span-label">
            <span>Players</span>
            <player-autocomplete-template ref="player_autocomplete" filtertype="addbet"></player-autocomplete-template>
          </v-col>
          <v-col cols="12" lg="3" class="span-label">
            <span>Contact number</span>
            <v-text-field
              readonly
              hide-details
              v-model="player.contact_no"
              class="regular-field"
              label="Contact #"
              :error-messages="playererror.contact_no"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="3" class="span-label">
            <span>Draws</span>
            <v-select
              hide-details
              class="regular-field"
              dense
              clearable
              :items="drawlist"
              item-value="id"
              item-text="name"
              label="Draw"
              v-model="entry.draw_id"
              @change="onDrawChange"
              :error-messages="formerror['entry.draw_id']"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            v-if="selectedDraw.pot == 'pot based'"
            class="span-label"
          >
            <span>Schedule</span>
            <v-select
              class="regular-field"
              clearable
              :items="selectedDraw.draw_schedules"
              label="Schedule"
              v-model="entry.potschedule"
              :error-messages="formerror['entry.potschedule']"
            ></v-select>
          </v-col>
        </v-row>
        <v-row align="center" class="d-flex justify-left">
          <!-- <v-col cols="12" lg="4"></v-col> -->
          <!-- <v-col cols="12" lg="3" v-if="entry.draw_id"> -->
          <!--  :rules="$inptrule.combi_rule(4)" -->
          <!--  @keypress.native="$inptrule.isNumber($event)" -->
          <!-- <v-text-field hide-details v-if="entry.draw_id" solo single-line dense clearable label="Combination" :maxlength="maxInput" v-model="entry.input" :error-messages="formerror['entry.input']"></v-text-field> -->
          <!-- </v-col> -->
          <v-col cols="12" lg="6" v-if="entry.draw_id">
            <v-row class="mb-n8 mt-2">
              <v-col cols="12" lg="12">
                <span
                  style="font-size: 16px;color: rgb(255, 255, 255);margin-bottom: 5px;display: block;"
                  >Bet combinations</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-for="(item, key) in this.selectedDraw.maxinput"
                :key="key"
              >
                <v-text-field
                  readonly
                  @click="betCombinationModal(key, digitLen)"
                  class="regular-field"
                  dense
                  :maxlength="digitLen"
                  v-model="separated_input[key]"
                  :error="separated_input_err"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-text-field hide-details v-model.number="entry.bet" solo single-line dense label="Amount" type="number" :min="0" :max="100" :step="5"  @blur="limitAmount()" :error-messages="formerror['entry.bet']"></v-text-field> -->
          </v-col>
          <v-col cols="12" lg="2" v-if="entry.draw_id" class="span-label">
            <span>Amount</span>
            <v-text-field
              class="regular-field"
              hide-details
              v-model.number="entry.bet"
              dense
              label="Amount"
              type="number"
              :min="0"
              :max="100"
              :step="5"
              @blur="limitAmount()"
              :error-messages="formerror['entry.bet']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="mt-7" md="4" lg="2" v-if="entry.draw_id">
            <v-switch
              hide-details
              inset
              class="mt-n1"
              v-model="entry.isramble"
              false-value="S"
              true-value="R"
              :disabled="isRambleDisable"
              label="Ramble"
              color="#19a5c7"
            ></v-switch>
          </v-col>

          <!-- <v-col cols="12" lg="10" align="center" v-if="entry.draw_id">
                                <v-alert border="left" color="#283e65" dark dense style="margin-bottom: 0px;">
                                    Minimum bet is ₱{{ selectedDraw.minimumbet | toNumberWithDecimal }} and maximum bet is ₱{{ selectedDraw.maxbet | toNumberWithDecimal }} for this draw.
                                </v-alert>
                            </v-col> -->
          <v-col
            cols="12"
            lg="2"
            v-if="entry.draw_id"
            class="mt-7"
            style="padding-top:7px;"
          >
            <v-btn
              block
              color="custom_info"
              @click="queue"
              :loading="isQueueLoading"
            >
              {{ player.combinations.length > 0 ? "Add bet" : "Add" }}</v-btn
            >
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row no-gutters class="">
          <v-col cols="12">
            <v-data-table
              hide-default-footer
              class="custom-header-color table-bordered table-striped"
              :headers="bet_headers"
              :items="player.combinations"
              item-key="id"
              disable-pagination
            >
              <template v-slot:[`item.combination`]="{ item }">
                <span>{{ item.combination }}</span>
                <span v-if="item.isramble == 'R'">R</span>
              </template>
              <template v-slot:[`item.bet`]="{ item }">
                <span>₱{{ item.bet | toNumberWithDecimal }}</span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn color="red_button" small @click="removeEntry(item)"
                  ><v-icon small>mdi-trash-can-outline</v-icon></v-btn
                >
              </template>
            </v-data-table>
          </v-col>

          <!-- <v-col cols="12">Bets remaining: {{ (expertmodeCounter >= 0) ? expertmodeCounter:0  }}</v-col> -->
          <v-col cols="12" class="mt-5"
            >Total bets: {{ totalbetcounter }}</v-col
          >
        </v-row>
      </v-card-text>

      <!-- <v-divider></v-divider> -->
      <v-card-actions class="actionButtons add-bet">
        <v-row
          no-gutters
          align="center"
          class="d-flex justify-end"
          v-if="!$vuetify.breakpoint.mobile"
        >
          <v-col cols="12" lg="2" xl="1" class="mr-xl-5 mr-lg-5 mr-md-0">
            <v-btn color="red_button" block dark @click="clearAllQueue"
              >Clear</v-btn
            >
          </v-col>
          <!-- <v-col cols="12" lg="2" xl="1" class="mr-xl-6 mr-lg-5 mr-md-5">
                                <v-btn color="custom_info" block dark @click="openExpertMode">Expert mode</v-btn>
                            </v-col> -->
          <v-col cols="12" lg="2" xl="1" class="mr-md-3">
            <v-btn
              color="green_button"
              block
              dark
              @click="send"
              :disabled="isSendBtnDisabled"
              :loading="isLoadingBtn"
              >{{ player.combinations.length > 1 ? "Send bets" : "Send" }}</v-btn
            >
          </v-col>
        </v-row>

        <v-row no-gutters align="center" class="d-flex justify-end" v-else>
          <v-col cols="12">
            <v-btn color="red_button" block dark @click="clearAllQueue"
              >Clear</v-btn
            >
          </v-col>
          <!-- <v-col cols="12" class="my-5">
                                <v-btn color="custom_info" block dark @click="openExpertMode">Expert mode</v-btn>
                            </v-col> -->
          <v-col cols="12">
            <v-btn
              color="green_button"
              block
              @click="send"
              :disabled="isSendBtnDisabled"
              :loading="isLoadingBtn"
              >Send</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <!-- </v-dialog> -->
    <!-- </section> -->

    <section>
      <v-dialog
        v-model="showExpertModeDialog"
        width="1200px"
        scrollable
        persistent
      >
        <v-card class="card-outline custom-color-dialog">
          <v-card-title class="headline headline_bg">
            <span>Expert mode</span>
          </v-card-title>

          <v-card-text>
            <v-row class="pt-6">
              <v-col cols="12">
                <span v-if="expertmodeCounter >= 0"
                  >Bets remaining: {{ expertmodeCounter }}</span
                >
                <span v-else style="color: #f56c6c"
                  >Bets remaining: {{ expertmodeCounter }}</span
                >
              </v-col>
              <v-col cols="12">
                <v-textarea
                  solo
                  single-line
                  v-model="expertModeTextArea"
                  auto-grow
                  :rows="10"
                  label="Place your entries"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- <v-divider></v-divider> -->
          <v-card-actions class="actionButtons pt-6">
            <v-row no-gutters>
              <v-col cols="6" lg="6" class="px-2">
                <v-btn color="red_button" @click="showExpertModeDialog = false"
                  >Close</v-btn
                >
              </v-col>
              <v-col cols="6" lg="6" class="px-2">
                <!-- <span v-if="$role.restricAccess($route.name, 'edit')"><v-btn color="info" class="float-right" @click="updateData" v-if="modalUpdate" :loading="isLoadingBtn">Update</v-btn></span>
                                <v-btn color="success" class="float-right" @click="newData" v-if="!modalUpdate" :loading="isLoadingBtn">Save</v-btn> -->
                <v-btn
                  color="green_button"
                  class="float-right mr-3"
                  :loading="isImporting"
                  dark
                  @click="importExpertMode"
                  >Import</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>

    <section>
      <v-dialog v-model="betCombination" width="550px">
        <div class="bet-numbers-outline pt-5 pb-5 px-5">
          <ul class="bet-numbers-selection">
            <li v-for="(item, key) in combinationList" :key="key">
              <button @click="betCombinationModalSelect(item)">
                {{ item }}
              </button>
            </li>
          </ul>
        </div>
      </v-dialog>
    </section>

    <confirm-dialog
      ref="confirm"
      class="custom-confirm-dialog"
    ></confirm-dialog>
  </section>
</template>

<script>
import APICONFIG from "/public/config.json";
import Utils from "../utils";

String.prototype.insert_at = function(index, string) {
  return this.substr(0, index) + string + this.substr(index);
};

export default {
  data() {
    return {
      bet_headers: [
        {
          text: "Draw",
          value: "draw_name",
          sortable: false,
          searchable: false,
        },
        {
          text: "Numbers",
          value: "combination",
          sortable: false,
          searchable: false,
        },
        { text: "Amount", value: "bet", sortable: false, searchable: false },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          searchable: false,
          width: "7%",
        },
      ],

      drawlist: [],
      selectedDraw: [],
      isRambleDisable: null,
      entry: new this.$Form({
        draw_id: null,
        potschedule: null,
        bet: 0,
        isramble: "",
        input: "",
      }),
      separated_input: [],

      player: new this.$Form({
        agent_id: null,
        player_id: null,
        contact_no: null,
        combinations: [],
        pa_id: null,
      }),
      groupcombination: [],
      playererror: {},

      isLoadingBtn: false,
      isSendBtnDisabled: false,
      // isLoadingBtnDelete: false,
      isQueueLoading: false,
      formerror: {},
      separated_input_err: false,
      modalUpdate: false,

      playersearch: "",

      expertmodeCounter: APICONFIG.BET_COUNTER_LIMIT,
      showExpertModeDialog: false,
      expertModeTextArea: "",
      isImporting: false,
      totalbetcounter: 0,
      betCombination: false,
      combinationList: [],
      selectedInputCombi: null,
    };
  },
  methods: {
    checkIsGMCanBet(){
      if(this.$store.state.currentUser.agent_data.canbet == 1){
          return true;
      }
      this.$router.push({path: '/error-404'});
      return false;
    },
    betCombinationModal(inputkey, maxLen) {
      let arr = [];
      let length = this.selectedDraw.comlength.split("-");
      for (let index = length[0]; index <= length[1]; index++) {
        let val = "";
        if (maxLen == 1) {
          val = index;
        } else {
          val = ("0" + index).slice(-2);
        }
        arr.push(val);
      }
      this.combinationList = arr;
      this.betCombination = true;
      this.selectedInputCombi = inputkey;
    },
    betCombinationModalSelect(val) {
      this.separated_input[this.selectedInputCombi] = val;
      this.betCombination = false;
      this.selectedInputCombi = null;
    },
    isnumberonly(event, message) {
      // let val = event.trim();
      // console.log(event);
      //                 if (!/\d/.test(event.key) &&
      //     (event.key !== "." || /\./.test(message))
      //   )
      //     return event.preventDefault();
      // // It can only be positive integer or empty, and the rule can be modified according to the requirement.
      // if (/^[1-9]\d*$|^$/.test(val)) {
      //     return null;
      // } else {
      //     event.target.value = val;
      // }
    },
    isNumeric(value) {
      return /^-?\d+$/.test(value);
    },
    getdraw() {
      return this.entry.draw_id && this.drawlist.length
        ? this.drawlist.find((d) => d.id == this.entry.draw_id)
        : null;
    },
    getmaxInput() {
      if (this.getdraw()) {
        let { numberformat, maxinput } = this.getdraw();
        let digitLen = numberformat.split("-")[1];
        digitLen = digitLen.length;
        // console.log(digitLen);
        return maxinput * digitLen;
      }
      return null;
    },
    openExpertMode() {
      this.expertModeTextArea = "";
      this.showExpertModeDialog = true;
    },
    async importExpertMode() {
      if (this.expertModeTextArea.length > 0) {
        // try {
        this.isImporting = true;
        await new Promise((resolve) => setTimeout(resolve, 500));

        if (await this.checkBetLimit()) return (this.isImporting = false);

        var draws = this.drawlist;
        let splitBets = this.expertModeTextArea.split("\n");

        let isValid = await this.checkImportModeEntries(draws, splitBets);
        if (!isValid) return (this.isImporting = false);

        let isBlocked = await this.checkBlockNumbers(draws, splitBets);
        if (!isBlocked) return (this.isImporting = false);

        await splitBets.reduce(async (promise, data_entry) => {
          if (data_entry.length > 0) {
            let data = await this.$_.split(data_entry, "/");
            let draw = await draws.filter((item) => item.codename == data[0]);
            let isRamble = data[2].includes("R");
            let betPrice = 0;

            if (isRamble) {
              isRamble = "R";
              betPrice = data[2].slice(0, -1);
            } else {
              isRamble = "S";
              betPrice = data[2];
            }

            let potschedule = null;
            if (draw[0].pot == "pot based") {
              let toNumber = data[3].toString();
              let search = toNumber.insert_at(2, "-");
              let myReg = new RegExp(search + ".*");

              draw[0].draw_schedules.forEach((entry, index) => {
                if (entry.match(myReg)) {
                  potschedule = draw[0].draw_schedules[index];
                }
              });
            }

            let entry = await {
              draw_id: draw[0].id,
              bet: parseInt(betPrice),
              isramble: isRamble,
              input: data[1],
              potschedule: potschedule,
            };

            console.log(potschedule);
            await this.groupcombinations(draw[0], entry);
            await this.handleEntry(draw[0], entry);
            await promise;
          }
        }, Promise.resolve());

        // CLEAR ENTRIES
        // this.entry.reset();
        this.showExpertModeDialog = false;
        this.isImporting = false;
        // this.$notify.closeAll();
        // this.isImporting = false;

        // } catch (error) {
        //     this.$toast.fire({ icon: 'error', title: "Invalid values" });
        // }
      }
    },
    async checkBlockNumbers(draws, splitBets) {
      let arrBets = [];
      let arrDraw = [];
      let arrCombinations = [];
      let isValid = true;
      splitBets.forEach((entry, index) => {
        if (entry.length > 0) {
          let entrydata = entry.split("/");
          let draw = draws.filter((item) => item.codename == entrydata[0]);

          arrCombinations.push({
            drawid: draw[0].id,
            bet: entrydata[1],
          });
        }
      });

      let response = await this.$axios.post(
        this.$_CONFIG.api("API_BET_ISBLOCK_EXPERTMODE"),
        { entries: arrCombinations }
      );
      if (response.data.length > 0) {
        isValid = await this.findBlockedCombinationOnEntries(
          splitBets,
          response.data
        );
      }
      return isValid;
    },
    async findBlockedCombinationOnEntries(splitBets, data) {
      let isValid = true;
      let blockedEntries = [];
      splitBets.forEach((entry, index) => {
        if (entry.length > 0) {
          data.forEach((blocked, key) => {
            let mergeBlock = blocked.draw + "/" + blocked.combination;
            if (entry.includes(mergeBlock)) {
              blockedEntries.push(entry);
              isValid = false;
            }
          });
        }
      });
      blockedEntries = [...new Set(blockedEntries)];
      blockedEntries.forEach((entry) => {
        this.$toast.fire({
          icon: "error",
          title: entry + " has reached its max limit.",
        });
      });
      return isValid;
    },
    async checkImportModeEntries(draws, splitBets) {
      var isValidImport = true;
      var specialchar = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~]/;
      var letters = /[a-zA-Z]/;
      splitBets.forEach((entry, index) => {
        if (entry.length > 0) {
          let entrydata = entry.split("/");
          let draw = draws.filter((item) => item.codename == entrydata[0]);
          let isRamble = entrydata[2].includes("R");
          let betPrice = 0;

          if (isRamble) {
            isRamble = "R";
            betPrice = entrydata[2].slice(0, -1);
          } else {
            isRamble = "S";
            betPrice = entrydata[2];
          }

          if (draw.length > 0) {
            // CHECK IF DRAW IS AVAILABLE
            this.entry = {
              draw_id: draw[0].id,
              bet: parseInt(betPrice),
              isramble: isRamble,
              input: entrydata[1],
            };

            if (draw[0]["draw_type"] == "straight" && isRamble == "R") {
              // CHECK IF DRAW CAN BE RAMBOL
              this.$toast.fire({
                icon: "error",
                title: "Error on entry: " + entry + " cannot be rambol",
              });
              isValidImport = false;
            }

            if (specialchar.test(entry) || letters.test(entrydata[1])) {
              // CHECK IF ENTRY HAS SPACES
              this.$toast.fire({
                icon: "error",
                title:
                  "Error on entry: " + entry + " check on special characters",
              });
              isValidImport = false;
            }

            if (entrydata[1].length != this.getmaxInput()) {
              // CHECK IF ENTRY BET MIN/MAX INPUT
              this.$toast.fire({
                icon: "error",
                title: "Invalid input count: " + entry,
              });
              isValidImport = false;
            }

            if (!parseInt(betPrice)) {
              // CHECK IF VALID BET NUMBER
              this.$toast.fire({
                icon: "error",
                title: entry + " invalid bet amount.",
              });
              isValidImport = false;
            }

            if (betPrice > draw[0].maxbet) {
              // CHECK IF BET RICH ITS MAXIMUM
              this.$toast.fire({
                icon: "error",
                title:
                  entry +
                  " maximum bet is PHP " +
                  draw[0].maxbet +
                  ".00 for this draw.",
              });
              isValidImport = false;
            }

            if (betPrice < draw[0].minimumbet) {
              // CHECK IF BET DID NOT RICH ITS MINIMUM
              this.$toast.fire({
                icon: "error",
                title:
                  entry +
                  " minimum bet is PHP " +
                  draw[0].minimumbet +
                  ".00 for this draw.",
              });
              isValidImport = false;
            }
          } else {
            this.$toast.fire({
              icon: "error",
              title: "Invalid draw entry: " + entry,
            });
            isValidImport = false;
          }
        }
      });

      // CLEAR ENTRIES
      this.entry = { draw_id: null, bet: 0, isramble: "S", input: "" };

      return isValidImport;
    },

    async removeEntry(entry) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete this record?"
        )
      ) {
        let index = this.player.combinations.indexOf(entry);
        if (index > -1) {
          this.removegroupcombinations(entry);
          this.player.combinations.splice(index, 1);
        }
      }
    },
    async removegroupcombinations(entry) {
      let isFound = false;
      let isFoundIndex = null;

      if (entry) {
        var combinations = entry.combination;
        combinations = combinations.split("-");
        if (this.groupcombination.length > 0) {
          this.groupcombination.forEach((row, index) => {
            let item = row.combination;
            item = item.split("-");

            let isSame = this.$_.isEqual(
              this.$_.sortBy(item),
              this.$_.sortBy(combinations)
            );
            if (isSame && row.drawid == entry.draw_id) {
              isFoundIndex = index;
              isFound = true;
            }
          });
        }
      }

      if (isFound) {
        let calculate = this.groupcombination[isFoundIndex].total - entry.bet;
        if (calculate > 0) {
          this.groupcombination[isFoundIndex].total -= entry.bet;
        } else {
          this.groupcombination.splice(isFoundIndex, 1);
        }
      }
    },
    async clearAllQueue() {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to clear this record?"
        )
      ) {
        this.modalForm();
      }
    },
    limitAmount() {
      let bet = this.entry.bet;
      let drawdata = this.selectedDraw;

      if (bet > this.selectedDraw.maxbet) {
        this.entry.bet = this.selectedDraw.maxbet;
      }

      if (bet < this.selectedDraw.minimumbet) {
        this.entry.bet = this.selectedDraw.minimumbet;
      }

      // this.entry.bet = Math.trunc(this.entry.bet);
      this.entry.bet = Math.ceil(this.entry.bet / 5) * 5; // CEIL TO NEAREST 5
    },
    onDrawChange() {
      this.separated_input = [];
      this.separated_input_err = false;
      if (!this.entry.draw_id) return null;

      let draw_id = this.entry.draw_id;
      this.formerror = {};
      this.entry.bet = 0;
      this.entry.input = "";
      this.entry.isramble = "S";
      let getDrawData = this.$_.filter(this.drawlist, function(x) {
        return x.id == draw_id;
      });
      this.selectedDraw = getDrawData[0];

      if (getDrawData[0].draw_type == "3d_rambol") {
        this.isRambleDisable = false;
      } else {
        this.isRambleDisable = true;
      }

      this.entry.bet = this.selectedDraw.minimumbet;
    },
    modalForm(data) {
      this.getDrawList();
      this.formerror = {};
      this.playererror = {};

      // this.entry.reset();
      this.entry = {
        draw_id: null,
        potschedule: null,
        bet: 0,
        isramble: "",
        input: "",
      };

      this.player.reset();
      this.selectedDraw = [];
      this.groupcombination = [];
      this.separated_input = [];
      this.separated_input_err = false;

      if (!this.$store.state.currentUser.isplayer) {
        this.$refs.player_autocomplete.autocomplete_model = [];
      }

      this.betcounterlimit();
    },
    async handleEntry(val_draw, val_entry) {
      try {
        let draw = val_draw;
        let entry = val_entry;

        let digitLen = draw.numberformat.split("-")[1].length;
        let combination = Utils.Format.combination(entry.input, digitLen);

        let potschedule = null;
        if (draw.pot == "pot based") {
          potschedule = entry.potschedule;
        }

        let identifier = entry.input;
        let draw_id = draw.id;
        let draw_name = draw.name;
        let max_accumulated = draw.max_accumulated;

        if (draw.draw_type == "3d_rambol") {
          if (entry.isramble == "R") {
            let combArr = Utils.Math.permutation(combination);
            let permuted = combArr.map((d) => {
              return {
                identifier,
                combination: d.join("-"),
                isramble: entry.isramble,
                bet: entry.bet,
              };
            });

            this.player.combinations.push({
              draw_name,
              draw_id,
              identifier,
              permuted,
              max_accumulated,
              combination: combination.join("-"),
              isramble: entry.isramble,
              bet: entry.bet,
              potschedule: potschedule,
            });
          } else {
            this.player.combinations.push({
              draw_name,
              draw_id,
              identifier,
              permuted: [],
              max_accumulated,
              combination: combination.join("-"),
              bet: entry.bet,
              isramble: entry.isramble,
              potschedule: potschedule,
            });
          }
        } else {
          this.player.combinations.push({
            draw_name,
            draw_id,
            identifier,
            permuted: [],
            max_accumulated,
            combination: combination.join("-"),
            bet: entry.bet,
            isramble: entry.isramble,
            potschedule: potschedule,
          });
        }
      } catch (error) {
        this.$toast.fire({ icon: "error", title: error });
      }
    },
    async checkBetLimit(isQueue = false) {
      let hasError = false;
      if (isQueue) {
        if (this.expertmodeCounter <= 0) {
          hasError = true;
        }
      } else {
        if (this.expertmodeCounter < 0) {
          hasError = true;
        }
      }

      if (hasError) {
        this.$toast.fire({
          icon: "error",
          title: "Max limit " + APICONFIG.BET_COUNTER_LIMIT + " has reached.",
        });
        return true;
      }
    },
    async queue() {
      this.separated_input_err = false;
      this.entry.input = this.separated_input.join("");

      if (!this.isNumeric(this.entry.input)) {
        this.formerror["entry.input"] = "Error";
        this.$toast.fire({
          icon: "error",
          title: "Invalid combination entry.",
        });
        return null;
      }
      if (await this.checkBetLimit(true)) return null;

      let isValidated = true;
      this.isQueueLoading = true;

      let isBlocked = await this.isblockbet();
      if (!isBlocked) {
        isValidated = false;
      }
      
      if (!this.validQueue()) {
        isValidated = false;
      }

      await this.groupcombinations(this.selectedDraw, this.entry);

      if (isValidated) {
        await this.handleEntry(this.selectedDraw, this.entry);
        this.expertmodeCounter -= 1;
        this.entry.input = "";
        this.separated_input = [];
        this.betcounterlimit();
      }
      this.isQueueLoading = false;
    },
    betcounterlimit() {
      // UPDATE BET LIMIT COUNTER
      let currentBets = this.player.combinations.length
        ? this.player.combinations.length
        : 0;
      this.expertmodeCounter = APICONFIG.BET_COUNTER_LIMIT - currentBets;
    },
    async groupcombinations(draw, entry) {
      let isFound = false;
      let isFoundIndex = null;

      let digitLen = draw.numberformat.split("-")[1].length;
      let combinations = Utils.Format.combination(entry.input, digitLen);

      if (this.groupcombination.length > 0) {
        this.groupcombination.forEach((row, index) => {
          let item = row.combination;
          item = item.split("-");

          let isSame = this.$_.isEqual(
            this.$_.sortBy(item),
            this.$_.sortBy(combinations)
          );

          if (isSame && row.drawid == entry.draw_id) {
            isFoundIndex = index;
            isFound = true;
          }
        });
      }

      if (isFound) {
        this.groupcombination[isFoundIndex].total += entry.bet;
      } else {
        this.groupcombination.push({
          drawid: entry.draw_id,
          max_accumulated: draw.maxbet,
          combination: combinations.join("-"),
          total: entry.bet,
        });
      }
      // console.log(this.groupcombination);
    },
    validQueue() {
      this.formerror = {};
      let bol = true;

      if (this.selectedDraw.pot == "pot based") {
        if (!this.entry.potschedule) {
          this.formerror["entry.potschedule"] = "Error";
          this.$toast.fire({ icon: "error", title: "Invalid draw schedule." });
          bol = false;
        }
      }

      if (this.entry.input.length != this.maxInput) {
        this.formerror["entry.input"] = "Error";
        this.$toast.fire({
          icon: "error",
          title: "Invalid combination entry.",
        });
        bol = false;
      }

      if (!this.entry.bet) {
        this.formerror["entry.bet"] = "Error";
        this.$toast.fire({ icon: "error", title: "Invalid bet entry." });
        bol = false;
      }

      if (!this.entry.draw_id) {
        this.formerror["entry.draw_id"] = "Error";
        this.$toast.fire({ icon: "error", title: "Invalid draw entry." });
        bol = false;
      }

      // console.log()

      return bol;
    },
    async isblockbet() {
      let bol = true;
      let draw = this.selectedDraw;
      let entry = this.entry;

      let digitLen = await draw.numberformat.split('-')[1].length;
      let combination = await Utils.Format.combination(entry.input, digitLen);
      combination = combination.join('-');
      
      await this.$axios.post(this.$_CONFIG.api('API_BET_ISBLOCK'), {draw:  draw, combination: combination}).then((data) => {
          bol = data.data;
      }).catch((err) => {
          this.$toast.fire({ icon: 'error', title: err.response.data.message });
          bol = false;
      });

      return bol;
    },
    send() {
      this.player.agent_id = this.$store.state.currentUser.agent_data.id;
      this.player.pa_id = this.$store.state.currentUser.agent_data.pa_id;

      if (this.$store.state.currentUser.isplayer) {
        this.player.player_id = this.$store.state.currentUser.player.id;
        this.player.contact_no = this.$store.state.currentUser.player.contact_no;
      }

      if (this.isLoadingBtn) return;
      this.isLoadingBtn = true;

      this.player.groupcombination = this.groupcombination;

      this.player
        .post(this.$_CONFIG.api("API_DRAW_TRANSACTION"))
        .then((data) => {
          this.player.groupcombination = [];
          this.groupcombination = [];
          this.isLoadingBtn = false;

          this.$toast.fire({ icon: "success", title: data.data.message });

          if (!this.$store.state.currentUser.isplayer) {
            this.$refs.player_autocomplete.formerror = {};
          }

          this.modalForm();
        })
        .catch((err) => {
          this.isLoadingBtn = false;
          this.playererror = err.response.data;
          if (!this.$store.state.currentUser.isplayer) {
            this.$refs.player_autocomplete.formerror = this.playererror;
          }

          let errs = "";
          if (!err.response.data.message) {
            errs = "Invalid entry";
          } else {
            errs = err.response.data.message;
          }
          this.$toast.fire({ icon: "error", title: errs });
        });

      this.inProgress = false;
      // console.log(this.player);
    },
    getDrawList() {
      this.$axios
        .get(this.$_CONFIG.api("API_DRAWLISTS"))
        .then((data) => {
          this.drawlist = data.data.data;
        })
        .catch((err) => {});
    },
    isSendButtonDisabled() {
      let isDisabled = false;
      if (this.player.combinations.length <= 0) {
        isDisabled = true;
      }
      this.isSendBtnDisabled = isDisabled;
    },
  },
  computed: {
    maxInput() {
      if (this.selectedDraw) {
        let { numberformat, maxinput } = this.selectedDraw;
        let digitLen = numberformat.split("-")[1].length;
        return maxinput * digitLen;
      }

      return null;
    },
    digitLen() {
      if (this.selectedDraw) {
        let { numberformat, maxinput } = this.selectedDraw;
        return numberformat.split("-")[1].length;
      }

      return null;
    },
  },
  watch: {
    expertModeTextArea: {
      handler() {
        if (this.expertModeTextArea.length > 1) {
          let splitBets = this.expertModeTextArea.split("\n");
          this.betcounterlimit();
          this.expertmodeCounter -= splitBets.length;
        } else {
          this.betcounterlimit();
        }
      },

      deep: true,
    },
    "player.combinations": {
      handler() {
        this.betcounterlimit();
        this.totalbetcounter = this.player.combinations.length;
        this.isSendButtonDisabled();
      },
      deep: true,
    },
    // 'player.contact_no':{
    //     handler() {
    //         this.isSendButtonDisabled();
    //     },
    //     deep: true
    // }
  },
  created() {
    // console.log(this.$store.state.currentUser.isplayer);
  },
  async mounted() {
    // console.log(APICONFIG.BET_COUNTER_LIMIT);
    // this.$Fire.$on("betdialogbox", (data) => {
    //   this.modalForm();
    // });

    // this.$refs.autocomplete.autocomplete_model = 35;
    // await new Promise(resolve => setTimeout(resolve, 5000));
    this.$watch(() => {
      if (!this.$store.state.currentUser.isplayer) {
        if (this.$refs.player_autocomplete.autocomplete_model) {
          let player_autocomplete = this.$refs.player_autocomplete
            .autocomplete_model;
          this.player.player_id = player_autocomplete.id;
          this.player.contact_no = player_autocomplete.contact;
        } else {
          this.player.player_id = null;
          this.player.contact_no = null;
        }
      }
    });
    this.modalForm();
  },
};
</script>
<style scoped>
.v-text-field .cs_betamount input {
  text-align: center !important;
}
</style>